export enum IdentityVerificationStatus {
  Active = 1,
  Success = 2,
  Failed = 3,
  Expired = 4,
  Canceled = 5,
  PendingReview = 6,
  Undefined = 7
}

export interface ProcessPlaidIdentityVerificationRequest {
  sessionId: string;
}

export interface ProcessPlaidIdentityVerificationResponse {
  financialApplicationId: string;
  sessionId: string;
  isSuccess: boolean;
  errorMessage?: string;
  status: IdentityVerificationStatus;
}
